import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import CSV from 'utils/CSV/index';
import config from '../../../../config.js';
import { I18nContext } from 'utils/I18n/context';

const images = {
    down: require('img/icons/down-arrow.svg'),
};

const csv = new CSV();

const StatisticsCSV = ({ data, headerName }) => {
    const { t } = useContext(I18nContext);

    const getData = useCallback(() => {
        let dataCopy = [...data];
        dataCopy.unshift(headerName);
        return dataCopy;
    }, [data, headerName]);

    const onDownload = useCallback(() => {
        let csvData = csv.convert(getData());
        csv.download(csvData, config.reportFileNameCSV);
    }, [getData]);

    const staticNames = t?.reportPage || {};

    return (
        <CustomTooltip id={`statistics-csv`} tooltip={staticNames.downloadCSV}>
            <a
                className="btn"
                id="statisticReport"
                onClick={onDownload}
            >
                 <img src={images.down} alt=""/>
            </a>
        </CustomTooltip>
    );
};

StatisticsCSV.propTypes = {
    data: PropTypes.array.isRequired,
    headerName: PropTypes.array.isRequired
};

StatisticsCSV.defaultProps = {};

export default StatisticsCSV;